import React, { useState } from 'react';
import { Card, Button, Form, Row, Col, Table, Badge } from 'react-bootstrap';
import UserForm from '../users/UserForm';
import axios from 'axios';

const OrgUserManagement = ({ org, users, fetchOrganizations, addUser, usersLoading }) => {
  const [assignForm, setAssignForm] = useState({
    userId: '',
    role: 'org_viewer'
  });

  const onAssignChange = e => setAssignForm({ ...assignForm, [e.target.name]: e.target.value });

  const handleAssignOrgMember = async (e) => {
    e.preventDefault();
    if (!assignForm.userId) return alert('Please select a user');
    try {
      await axios.post(`/api/organizations/${org._id}/members`, {
        userId: assignForm.userId,
        role: assignForm.role
      });
      alert('Member assigned to Organization successfully');
      setAssignForm({ userId: '', role: 'org_viewer' });
      if (fetchOrganizations) fetchOrganizations();
    } catch (err) {
      console.error(err);
      alert('Failed to assign member');
    }
  };

  return (
    <div className="org-user-management">
      <Row>
        <Col md={7}>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h5 className="font-weight-bold text-dark mb-0">Organization Team Directory</h5>
          </div>

          <div className="table-responsive shadow-sm rounded border bg-white mb-4">
            <Table hover className="mb-0">
              <thead className="bg-light">
                <tr>
                  <th>Name</th>
                  <th>Username / Phone</th>
                  <th width="150" className="text-center">Organization Role</th>
                </tr>
              </thead>
              <tbody>
                {org.members && org.members.length > 0 ? (
                  org.members.map(member => {
                    const u = users.find(usr => usr._id === member.user);
                    return (
                      <tr key={member.user}>
                        <td className="py-3 font-weight-bold align-middle">
                          {u ? u.name : 'Unknown User'}
                          {org.ownerId === member.user && (
                            <Badge variant="primary" className="ml-2 font-weight-bold small">OWNER</Badge>
                          )}
                        </td>
                        <td className="py-3 align-middle text-muted small">
                          {u ? (u.username || u.phone) : '—'}
                        </td>
                        <td className="py-3 text-center align-middle">
                          <Badge variant={member.role === 'org_admin' ? 'success' : 'secondary'}>
                            {member.role === 'org_admin' ? 'ADMIN' : 'MEMBER'}
                          </Badge>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="3" className="text-center py-4 text-muted">No members assigned</td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>

          <Card className="shadow-sm border-0 mb-4">
            <Card.Body>
              <Card.Title className="h6 font-weight-bold text-muted small text-uppercase mb-3">Add Existing User to Org</Card.Title>
              <Form onSubmit={handleAssignOrgMember}>
                <Row className="align-items-end">
                  <Col md={5}>
                    <Form.Group className="mb-0">
                      <Form.Label className="small font-weight-bold">Select User</Form.Label>
                      <Form.Control
                        as="select"
                        name="userId"
                        value={assignForm.userId}
                        onChange={onAssignChange}
                        size="sm"
                        required
                      >
                        <option value="">-- Choose User --</option>
                        {users.map(u => <option key={u._id} value={u._id}>{u.name} ({u.username || u.phone})</option>)}
                      </Form.Control>
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group className="mb-0">
                      <Form.Label className="small font-weight-bold">Role</Form.Label>
                      <Form.Control
                        as="select"
                        name="role"
                        value={assignForm.role}
                        onChange={onAssignChange}
                        size="sm"
                      >
                        <option value="org_viewer">Member (Read-only)</option>
                        <option value="org_admin">Admin (Full Control)</option>
                      </Form.Control>
                    </Form.Group>
                  </Col>

                  <Col md={3}>
                    <Button type="submit" variant="primary" size="sm" block>
                      Add Member
                    </Button>
                  </Col>
                </Row>
              </Form>
            </Card.Body>
          </Card>
        </Col>

        <Col md={5}>
          <UserForm onAdd={addUser} />
        </Col>
      </Row>
    </div>
  );
};

export default OrgUserManagement;
